<template>
  <div>
    <!-- Seçenek Kutusu -->
    <div class="form-group col-5">
      <label for="timeFilter">{{ $t('dashboard.select.timeRange.label') }}</label>
      <select v-model="selectedTimeRange" @change="getUserLog" class="form-control" id="timeFilter">
        <option value="today">{{ $t('dashboard.select.timeRange.daily') }}</option>
        <option value="oneWeekAgo">{{ $t('dashboard.select.timeRange.weekly') }}</option>
        <option value="oneMonthAgo">{{ $t('dashboard.select.timeRange.monthly') }}</option>
        <option value="oneYearAgo">{{ $t('dashboard.select.timeRange.yearly') }}</option>
      </select>
    </div>

    <!--Stats cards-->
    <div class="row">
      <div
        class="col-md-6 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div class="icon-big text-center" slot="header">
            <!-- Icon URL'yi kullanarak resmi göster -->
            <img :src="getIconUrl(stats.icon)" alt="Icon" width="40px" height="40px" />
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ $t('dashboard.stats.updatedNow') }}
          </div>
        </stats-card>
      </div>
    </div>

    <!--Charts-->
    <div class="row">
      <!-- Add your chart cards here as needed -->
    </div>
  </div>
</template>

<script>
import { StatsCard } from "@/components/index";
import axios from "axios";
import config from "@/routing_map.json"; // Config dosyasından app_url'yi alıyoruz
import router from "@/router";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate.vue";

export default {
  components: {
    StatsCard,
  },
  data() {
    return {
      logs: null,
      statsCards: [],
      selectedTimeRange: 'oneWeekAgo',  // Default olarak günlük seçili
    };
  },
  created() {
    this.getUserLog();  // Varsayılan olarak "Günlük" verileri getirsin
  },
  methods: {
    getUserLog() {
      const app_data = this;
      const query = this.getQueryParamForTimeRange(this.selectedTimeRange);  // Seçilen zaman dilimi için query al

      // API isteğini yapmak için gerekli authorization header'ı ekleyelim
      axios.defaults.headers.common.authorization = localStorage.getItem(
        "authorization"
      );

      axios
        .get(`${config.app_url}/user/get-user-preview-log`, {
          params: { timeRange: query }  // Zaman aralığı için query gönder
        })
        .then((response) => {
          if (response.data.success) {
            app_data.logs = response.data.msg;

            // Gelen verileri statsCards'a dönüştür
            app_data.statsCards = response.data.msg.map((log) => ({
              type: log.type.toLowerCase(),
              icon: log.icon,  // Gelen icon alanını kullan
              title: log.type,
              value: log.count,
              footerText: "Updated now",
              footerIcon: "ti-reload",
            }));
          } else {
            app_data.notifyVue(
              "top",
              "right",
              this.$t('dashboard.notifications.dataNotGet'),
              "warning"
            );
          }
        })
        .catch((error) => {
          router.push("login");
          app_data.notifyVue("top", "right", this.$t('dashboard.notifications.connectionError'), "warning");
        });
    },

    // İkonu göstermek için config.app_url ile birleştirme
    getIconUrl(iconName) {
      return `${config.app_url}/uploads/icons/${iconName}`; // icon URL'yi app_url ile birleştiriyoruz
    },

    // Seçilen zaman dilimine göre query parametrelerini belirleyen fonksiyon
    getQueryParamForTimeRange(timeRange) {
      return timeRange;
    },

    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        duration: 2000,
      });
    },
  },
};
</script>

<style></style>
